import { useSendContact } from '@/modules/static/application';

import { useToast } from '@packages/web-design-systems';

import { mapContactUsFormToDto } from '../mappers/contact-us.form-to-dto.mapper';
import type { ContactUsFormModel } from '../models/contact-us.form-model';

export const useContactUsForm = () => {
	const { submit } = useSendContact();
	const { showError, showSuccess } = useToast();

	const execute = (form: ContactUsFormModel) => {
		const result = submit(mapContactUsFormToDto(form));

		return result.isFailure
			? showError({ title: 'There was an error submitting the form. Please try again later.' })
			: showSuccess({ title: 'Your message has been sent successfully!' });
	};

	return { execute };
};
